
export enum ERoles {
  SUPERVISOR = 'supervisor',
  MANAGER_ADMIN = 'managerAdmin',
  REGIONAL = 'regional'
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/enums/e-roles.enum.ts